// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero__hero___1x8G9","hero__value":"hero__hero__value___2VU_o","hero__label":"hero__hero__label___8JsnZ"};